// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function reactionCreate(params: {
  type: "❤️" | "😆" | "🤮"
  note_id: string
}) {
  return http<{
    id: string
    type: "❤️" | "😆" | "🤮"
    note_id: number
    user: {
      id: number
      name: string
      email: string
      avatar_url: string
    }
    created: string
  }>({
    url: "/api/v1/notes/{note_id}/reactions/",
    method: "post",
    params,
    pathParamNames: ["note_id"],
  })
}
